import React, { useState } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { braintree } from 'variables'
import Form, {
  FormButton,
  FormFieldset
} from '../../../../common/components/Form'
import { Avatar } from '../../../../common/components/Avatar'
import { LabelSpacer } from '../../../../common/components/Label/Label'
import Text, { Paragraph } from '../../../../common/components/Text'
import { asModal, ModalTitle } from '../../../../common/Modal/Modal'
import Icon from 'common/components/Icon'
import UserMessage from './UserMessage'

const CancelSubModal = ({ user, subscription, close }) => {
  const { t } = useTranslation()
  const [canceling, setCanceling] = useState()
  const [error, setError] = useState()

  if (!subscription)
    return (
      <>
        <Form>
          <UserMessage>
            <Avatar name={user.displayName} large />
            <Text>
              <Trans
                i18nKey="settings.cancelSub.canceled"
                values={{ plan: t('plans.basic.name') }}
              >
                You’re on <Text bold>Free</Text>
              </Trans>
            </Text>
          </UserMessage>

          <FormButton xLarge onClick={close} type="button">
            {t('settings.cancelSub.continue')}
            <LabelSpacer />
            <Icon icon="arrow-right" />
          </FormButton>
        </Form>
      </>
    )

  const cancel = async () => {
    setCanceling(true)
    setError(null)
    const response = await fetch(braintree.cancel, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'post',
      body: JSON.stringify({
        userId: user.uid,
        subscriptionId: subscription.id
      })
    })
      .then(r => r.json())
      .catch(setError)
    setCanceling(false)
    if (!response) {
      return
    }

    console.log(response)
    if (response.error) setError(response.error)
  }

  const daysRemaining = Math.round(
    Math.min(
      30,
      (new Date(subscription.nextBillingDate) - new Date()) /
        (1000 * 60 * 60 * 24)
    )
  )
  const refund =
    Math.round(subscription.price * (daysRemaining / 30) * 100) / 100

  return (
    <>
      <ModalTitle>
        <Text>{t('settings.cancelSub.title')}</Text>
      </ModalTitle>
      <Form>
        <Paragraph grey>
          {t('settings.cancelSub.warning', {
            plan: t(`plans.${subscription.planId}.name`)
          })}
        </Paragraph>
        <Paragraph grey>
          {t('settings.cancelSub.refundNote', { refund, daysRemaining })}
        </Paragraph>
        {error && (
          <Paragraph red>
            {t('settings.cancelSub.error', { refund, daysRemaining })}
          </Paragraph>
        )}
        <FormFieldset>
          <FormButton xLarge onClick={cancel} disabled={canceling}>
            {t('settings.cancelSub.cancel')}
            <LabelSpacer />
            <Icon icon={canceling ? 'loader' : 'arrow-right'} />
          </FormButton>
        </FormFieldset>
      </Form>
    </>
  )
}

export default asModal({ small: true })(CancelSubModal)
